var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75742 52.829V50.7581H48.2449V52.829H4.75742ZM4.75742 2.24149V0.170654H48.2449V2.24149H4.75742ZM26.5012 33.304C28.4241 33.304 30.0635 32.626 31.4194 31.2701C32.7753 29.9142 33.4532 28.2748 33.4532 26.3519C33.4532 24.429 32.7753 22.7896 31.4194 21.4337C30.0635 20.0778 28.4241 19.3998 26.5012 19.3998C24.5782 19.3998 22.9388 20.0778 21.5829 21.4337C20.227 22.7896 19.5491 24.429 19.5491 26.3519C19.5491 28.2748 20.227 29.9142 21.5829 31.2701C22.9388 32.626 24.5782 33.304 26.5012 33.304ZM5.20117 46.3206C3.91923 46.3206 2.85916 45.9015 2.02096 45.0634C1.18277 44.2252 0.763672 43.1651 0.763672 41.8831V11.1165C0.763672 9.83454 1.18277 8.77447 2.02096 7.93628C2.85916 7.09808 3.91923 6.67899 5.20117 6.67899H47.8012C49.0831 6.67899 50.1432 7.09808 50.9814 7.93628C51.8196 8.77447 52.2387 9.83454 52.2387 11.1165V41.8831C52.2387 43.1651 51.8196 44.2252 50.9814 45.0634C50.1432 45.9015 49.0831 46.3206 47.8012 46.3206H5.20117ZM13.0408 44.2498H39.9616C37.7428 42.4748 35.5241 41.1929 33.3053 40.404C31.0866 39.6151 28.8185 39.2206 26.5012 39.2206C24.1838 39.2206 21.9158 39.6151 19.697 40.404C17.4783 41.1929 15.2595 42.4748 13.0408 44.2498Z",
    fill: "#80ABFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg);
export default __webpack_public_path__ + "static/media/profileImg.6218554a5578ccac2f72a678c332e7ca.svg";
export { ForwardRef as ReactComponent };